import React, { FunctionComponent, PropsWithChildren } from 'react';
import { Box, styled } from '@mui/material';
import { Close } from '@mui/icons-material';

export type MoDismissableBannerProps = {
  isOpen: boolean;
  onClose?: () => void;
};

const StyledBox = styled(Box)(({ theme }) => ({
  background: theme.palette.bluebell.main,
  color: 'white',
  padding: '.5rem',
  display: 'flex',
  position: 'relative',
  '& a': {
    color: 'white',
    textDecoration: 'underline',
  },
}));

export const MoDismissableBanner: FunctionComponent<
  PropsWithChildren<MoDismissableBannerProps>
> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <StyledBox
      sx={{
        justifyContent: { xs: 'space-between', sm: 'center' },
      }}
    >
      <Box>{children}</Box>
      {onClose && (
        <Close
          cursor="pointer"
          sx={{
            position: { sm: 'absolute' },
            right: { sm: '.5rem' },
          }}
          onClick={() => onClose()}
        />
      )}
    </StyledBox>
  );
};
